
import easyLife365_Mail from "../../assets/svg/logos/easylife365_mail_logo.svg"
import easyMeet365 from "../../assets/svg/logos/easylife365_easymeet_logo.svg"
import meetHeroSection from "../../assets/images/products/Meet-HeroSection.png"
import mailHeroSection from "../../assets/images/products/Mail-HeroSection.svg"
import tipsterHeroSection from "../../assets/images/products/tipster/EasyTipster_mockups.png"
import CollabHero from '../../assets/images/products/Collab-HeroSection.svg'
import easyLife365_Collab from '../../assets/svg/logos/easylife365_collaboration_logo.svg'
import easyLife365_Tipster from "../../assets/images/products/easyLife365_Tipster.svg"
import easyLife365_Identity from "../../assets/svg/logos/easylife365_identity_logo.svg"
import identityHeroSection from "../../assets/images/products/identity/Identity-HeroSection.png"
import easyLife365_Identity_new from "../../assets/svg/logos/easylife365_identity_logo.svg"

//collab Images
import accessReviewsAndApprovals from "../../assets/images/products/collab/access_management/access_reviews.svg";
import guestAccountOnboardingAndOffboarding from "../../assets/images/products/collab/access_management/guest_onboarding.svg";
import archiveAndCleanup from "../../assets/images/products/collab/access_management/archive_and_cleanup.svg";
import basicTemplates from "../../assets/images/products/collab/templates_and_provisioning/basic_templates.svg";
import customTemplatesWithYourData from "../../assets/images/products/collab/templates_and_provisioning/custom_templates.svg";
import advancedProvisioningActions from "../../assets/images/products/collab/templates_and_provisioning/advanced_provisioning.svg";
import lifecycleManagement from "../../assets/images/products/collab/policies/lifecycle_management.svg";
import ownerAndGuestUserPolicies from "../../assets/images/products/collab/policies/owner_and_guest_user_policies.svg";
import monitoringAndAudit from "../../assets/images/products/collab/policies/monitoring_and_audit.svg";
import logToReport from "../../assets/images/products/collab/reporting_and_integrations/log_to_report.svg";
import comprehensiveAdminOverview from "../../assets/images/products/collab/reporting_and_integrations/comprehensive_admin_overview.svg";
import integratedInYourToolchain from "../../assets/images/products/collab/reporting_and_integrations/integrated_in_your_toolchain.svg";

// Mail Images
import accessReviews from "../../assets/images/products/mail/access_management/access_reviews.svg";
import approvalWorkflows from "../../assets/images/products/mail/access_management/approval_workflows.svg";
import automatedEscalations from "../../assets/images/products/mail/access_management/automated_escalations.svg";

import guestUserPoliciesForDistributionLists from "../../assets/images/products/mail/policies/guest_user_policies_for_distribution_lists.svg";
import lifecycleManagement_mail from "../../assets/images/products/mail/policies/lifecycle_management.svg";
import ownerPolicies from "../../assets/images/products/mail/policies/owner_policies.svg";

import comprehensiveAdminOverview_mail from "../../assets/images/products/mail/reporting_and_integrations/comprehensive_admin_overview.svg";
import integratedInMicrosoftTeamsAndOutlook from "../../assets/images/products/mail/reporting_and_integrations/integrated_in_microsoft_teams_and_outlook.svg";
import trackAndAnalyzeGovernanceActions from "../../assets/images/products/mail/reporting_and_integrations/track_and_analyze_governance_actions.svg";

import customizableTemplatesForMailResources from "../../assets/images/products/mail/templates_and_provisioning/customizable_templates_for_mail_resources.svg";
import flexibleProvisioning from "../../assets/images/products/mail/templates_and_provisioning/flexible_provisioning.svg";
import smartSchedulingAndResourceManagement from "../../assets/images/products/mail/templates_and_provisioning/smart_scheduling_and_resource_management.svg";

import expertOnTheWayMail from "../../assets/images/products/mail/expert_on_the_way_mail.svg";

// Meet Images
import calendarAndNotifications from "../../assets/images/products/meet/calendar_and_notifications.svg";
import expertOnTheWayMeet from "../../assets/images/products/meet/expert_on_the_way_meet.svg";
import pollAndScheduling from "../../assets/images/products/meet/poll_and_scheduling.svg";
import userFriendlyAccess from "../../assets/images/products/meet/user_friendly_access.svg";

// Identity Images
import accountabilityinsights from "../../assets/images/products/identity/access_management/accountabilityandactionableinsights.svg";
import appoverviewandtracking from "../../assets/images/products/identity/access_management/appoverviewandtracking.svg";
import expirationmanagement from "../../assets/images/products/identity/access_management/expirationmanagement.svg";

import automatedcompliancecheck from "../../assets/images/products/identity/compliance/automatedcompliancecheck.svg";
import customnotifications from "../../assets/images/products/identity/compliance/customnotifications.svg";
import msteamsnotifications from "../../assets/images/products/identity/compliance/msteamsnotifications.svg";

import automatedcertificatesandsecrets from "../../assets/images/products/identity/automation_integration/automatedcertificatesandsecrets.svg";
import custommetadatamanagement from "../../assets/images/products/identity/automation_integration/custommetadatamanagement.svg";
import itinfrastructureintegration from "../../assets/images/products/identity/automation_integration/itinfrastructureintegration.svg";

export type ProductItem = {
  title: string
  Svg: string
  description: string
  link?: string
  basicsLink?: string
  type: string
  features?: string[]
  customActionButtonText?: string
  isSecondaryButton?: boolean
  backgroundColor?: string
  isProduct?: boolean
  msCertifiedLink?: string
  HeroImg?: string;
  customLink?: string;
  hideDemoButton?: boolean;
  downloadBrochureLink: boolean
}

export interface FeatureProps extends ProductItem {
  isLandingPage: boolean;
}

export const ProductList: ProductItem[] = [
  {
    title: "productlist.collab.title",
    Svg: easyLife365_Collab,
    HeroImg: CollabHero,
    description: "productlist.collab.description",
    type: "collab",
    msCertifiedLink: "https://learn.microsoft.com/en-us/microsoft-365-app-certification/teams/easylife-365-ag?pivots=general",
    hideDemoButton: false,
    downloadBrochureLink: true
  },
  {
    title: "productlist.mail.title",
    Svg: easyLife365_Mail,
    HeroImg: mailHeroSection,
    description: "productlist.mail.description",
    type: "mail",
    msCertifiedLink: "https://appsource.microsoft.com/en-us/product/office/WA200006531",
    hideDemoButton: false,
    downloadBrochureLink: true
  },
  {
    title: "productlist.identity.title",
    Svg: easyLife365_Identity,
    HeroImg: identityHeroSection,
    description: "productlist.identity.description",
    type: "identity",
    msCertifiedLink: "https://learn.microsoft.com/en-us/microsoft-365-app-certification/teams/easylife-365-ag-identity?pivots=general",
    customLink: "https://onboarding.easylife365.cloud/wizard/identity",
    customActionButtonText: "productlist.identity.customActionButtonText",
    hideDemoButton: true,
    downloadBrochureLink: true
  },
  {
    title: "productlist.meet.title",
    Svg: easyMeet365,
    HeroImg: meetHeroSection,
    description: "productlist.meet.description",
    type: "meet",
    msCertifiedLink: "https://learn.microsoft.com/en-us/microsoft-365-app-certification/teams/easylife-365-ag-easymeet?pivots=general",
    customLink: "https://appsource.microsoft.com/en-us/product/office/wa200005731?tab=overview",
    customActionButtonText: "productlist.meet.customActionButtonText",
    hideDemoButton: false,
    downloadBrochureLink: true
  },
  {
    title: "productlist.tipster.title",
    Svg: easyLife365_Tipster,
    HeroImg: tipsterHeroSection,
    description: "productlist.tipster.description",
    type: "tipster",
    customLink: "https://app.easytipster.cloud",
    customActionButtonText: "productlist.tipster.customActionButtonText",
    hideDemoButton: false,
    downloadBrochureLink: false
  },
];

export const ProductFeatureList: ProductItem[] = [
  {
    title: "productFeatureList.collaboration.title",
    Svg: easyLife365_Collab,
    description: "productFeatureList.collaboration.description",
    link: "products/collaboration",
    type: "collab",
    basicsLink: "/products/collaboration",
    features: [
      "productFeatureList.collaboration.features.facilitateCollaboration",
      "productFeatureList.collaboration.features.empowerEndUsers",
      "productFeatureList.collaboration.features.keepWorkplaceClean",
      "productFeatureList.collaboration.features.increaseSecurity"
    ],
    isProduct: true,
    msCertifiedLink: "https://learn.microsoft.com/en-us/microsoft-365-app-certification/teams/easylife-365-ag?pivots=general",
    hideDemoButton: false,
    downloadBrochureLink: true
  },
  {
    title: "productFeatureList.mail.title",
    Svg: easyLife365_Mail,
    description: "productFeatureList.mail.description",
    link: "products/mail",
    type: "mail",
    basicsLink: "/products/mail",
    features: [
      "productFeatureList.mail.features.defineOwnership",
      "productFeatureList.mail.features.creationOfAssets",
      "productFeatureList.mail.features.usageAndMaintenance",
      "productFeatureList.mail.features.cleanupAndArchive"
    ],
    isProduct: true,
    msCertifiedLink: "https://appsource.microsoft.com/en-us/product/office/WA200006531",
    hideDemoButton: false,
    downloadBrochureLink: true
  },
  {
    title: "productFeatureList.identity.title",
    Svg: easyLife365_Identity_new,
    description: "productFeatureList.identity.description",
    link: "products/identity",
    type: "identity",
    basicsLink: "/products/identity",
    isProduct: true,
    msCertifiedLink: "https://learn.microsoft.com/en-us/microsoft-365-app-certification/teams/easylife-365-ag-identity?pivots=general",
    hideDemoButton: true,
    downloadBrochureLink: true
  },
  {
    title: "productFeatureList.meet.title",
    Svg: easyMeet365,
    description: "productFeatureList.meet.description",
    link: "https://appsource.microsoft.com/en-us/product/office/wa200005731?tab=overview",
    type: "meet",
    basicsLink: "/products/meet",
    features: [
      "productFeatureList.meet.features.createPolls",
      "productFeatureList.meet.features.reserveTimeslots",
      "productFeatureList.meet.features.secureAndConfidential",
      "productFeatureList.meet.features.acrossOrganizations"
    ],
    customActionButtonText: "productFeatureList.meet.customActionButtonText",
    isProduct: true,
    msCertifiedLink: "https://learn.microsoft.com/en-us/microsoft-365-app-certification/teams/easylife-365-ag-easymeet?pivots=general",
    hideDemoButton: true,
    downloadBrochureLink: true
  },
  {
    title: "productFeatureList.partnerNetwork.title",
    Svg: "", // No Svg provided
    description: "productFeatureList.partnerNetwork.description",
    link: "/partners/our-partners/",
    type: "partnerNetwork",
    basicsLink: "/partners/our-partners/",
    features: [
      "productFeatureList.partnerNetwork.features.mitigation",
      "productFeatureList.partnerNetwork.features.onboarding",
      "productFeatureList.partnerNetwork.features.support",
      "productFeatureList.partnerNetwork.features.consulting"
    ],
    customActionButtonText: "productFeatureList.partnerNetwork.customActionButtonText2",
    isProduct: false,
    hideDemoButton: true,
    downloadBrochureLink: false
  },
];

export interface FeatureProps extends ProductItem {
  isLandingPage: boolean;
}


export enum ProductType {
  Collab = 'collab',
  Mail = 'mail',
  Meet = 'meet',
  Tipster = 'tipster',
  Identity = 'identity',
}

type ProductImageMapping = {
  [featureKey: string]: string;
};

// Example Mapping
const imageMapping: Record<string, string> = {
  // Collab
  accessReviewsAndApprovals: accessReviewsAndApprovals,
  guestAccountOnboardingAndOffboarding: guestAccountOnboardingAndOffboarding,
  archiveAndCleanup: archiveAndCleanup,
  basicTemplates: basicTemplates,
  customTemplatesWithYourData: customTemplatesWithYourData,
  advancedProvisioningActions: advancedProvisioningActions,
  lifecycleManagement: lifecycleManagement,
  ownerAndGuestUserPolicies: ownerAndGuestUserPolicies,
  monitoringAndAudit: monitoringAndAudit,
  logToReport: logToReport,
  comprehensiveAdminOverview: comprehensiveAdminOverview,
  integratedInYourToolchain: integratedInYourToolchain,

  // Mail
  accessReviews: accessReviews,
  approvalWorkflows: approvalWorkflows,
  automatedEscalations: automatedEscalations,
  guestUserPoliciesForDistributionLists: guestUserPoliciesForDistributionLists,
  lifecycleManagement_mail: lifecycleManagement,
  ownerPolicies: ownerPolicies,
  comprehensiveAdminOverview_mail: comprehensiveAdminOverview,
  integratedInMicrosoftTeamsAndOutlook: integratedInMicrosoftTeamsAndOutlook,
  trackAndAnalyzeGovernanceActions: trackAndAnalyzeGovernanceActions,
  customizableTemplates: customizableTemplatesForMailResources,
  flexibleProvisioning: flexibleProvisioning,
  smartSchedulingAndResourceManagement: smartSchedulingAndResourceManagement,

  // Meet

  easyAuthentication: userFriendlyAccess,
  magicLinksForExternalUsers: userFriendlyAccess,
  delegateFunctionality: userFriendlyAccess,
  meetingPollCreation: pollAndScheduling,
  customTimeslotSelection: pollAndScheduling,
  automaticMeetingScheduling: pollAndScheduling,
  calendarIntegration: calendarAndNotifications,
  notificationAndSharing: calendarAndNotifications,
  microsoft365Integration: calendarAndNotifications,

  // Identity
  appOverview: appoverviewandtracking,
  expirationManagement: expirationmanagement,
  accountability: accountabilityinsights ,
  automatedCompliance: automatedcompliancecheck,
  customNotifications: customnotifications ,
  teamsNotifications:msteamsnotifications ,
  automatedRenewal: automatedcertificatesandsecrets,
  integratedInfrastructure: itinfrastructureintegration,
  customMetadataMamangement:custommetadatamanagement ,

};
/**
 * Retrieve the image for a given feature key.
 *
 * @param featureKey - The key corresponding to the feature
 * @returns The imported image module or undefined if not found
 */
export function getImageForFeature(featureKey: string): string {
  return imageMapping[featureKey];
}